import React from 'react';
import Layout from 'components/layout';
import LayoutEmpty from 'components/layout-empty';
import { LocaleProvider } from 'providers/locale-provider';

export default ({ element, ...rest }) => (
  <>
    <LocaleProvider locale={rest.props.pageContext.locale}>
      { rest.props.uri.indexOf('/link') === -1 ? <Layout {...rest}>{element}</Layout>
        : <LayoutEmpty {...rest}>{element}</LayoutEmpty>
      }
    </LocaleProvider>
  </>
);
